import { Alert, Heading, Paragraph } from '@digdir/designsystemet-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MightLoseDataWarning = () => {
  const { t } = useTranslation();

  return (
    <Alert data-color="warning">
      <Heading data-size="xs" level={2}>
        {t('form.valgfriDetaljering.warning.title')}
      </Heading>
      <Paragraph>{t('form.valgfriDetaljering.warning.info')}</Paragraph>
    </Alert>
  );
};
